import { Component, inject } from '@angular/core';
import { KpiWidgetComponent } from '../../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services/filter.service';
import { TranslocoService } from '@jsverse/transloco';
import { InsuranceClaimsService } from '../../../services/insurance-claims.service';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { SummaryRequest } from '../../../../../../_shared/models/summary-request.model';

@Component({
  selector: 'app-total-claims',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './total-claims.component.html',
  styleUrl: './total-claims.component.scss'
})
export class TotalClaimsComponent extends BaseWidgetComponent {
  private claimsService = inject(InsuranceClaimsService);
  private errorService = inject(ErrorHandlerService);

  hasError: boolean = false;
  errorMessage: string = '';

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);

    const transloco: TranslocoService = inject(TranslocoService);
    this.title = transloco.translate('accidents.claims.widgets.totalClaims');
    this.isLoading = true;
    this.value = 0;
    this.percentageDifference = 0;
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;

    try {
      this.cancelSubject.next();
      const request: SummaryRequest = {
        accountIds: this.widgetFilter.accountIds,
        timeFrom: this.widgetFilter.startDate!,
        timeTo: this.widgetFilter.endDate!,
        interval: this.widgetFilter.interval,
        previousTimeFrom: this.widgetFilter.previousCycleStartDate!,
        previousTimeTo: this.widgetFilter.previousCycleEndDate!
      };
      const response = await this.claimsService.getTotalClaimsKpi(request, this.cancelSubject);
      this.value = response.data?.totalValue ?? 0;
      this.percentageDifference = response.data?.percentageChange ?? 0;

      this.isLoading = false;
    } catch (error: any) {
      this.errorService.handleError(error, {
        callback: (errorMessage) => {
          this.hasError = true;
          this.errorMessage = errorMessage;
          this.isLoading = false;
        }
      });
    }
  }

  public override formatValue(value: number): string {
    return `${value.toLocaleString()}`;
  }
}